import { render, staticRenderFns } from "./AssignFileModal.vue?vue&type=template&id=b2b994dc&scoped=true"
import script from "./AssignFileModal.vue?vue&type=script&lang=ts"
export * from "./AssignFileModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b994dc",
  null
  
)

export default component.exports